import { render } from "./MarathonCard.vue?vue&type=template&id=30632382"
import script from "./MarathonCard.vue?vue&type=script&lang=js"
export * from "./MarathonCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__